import Head from "next/head";

const PageHead = ({ title, category }) => {
  let newTitle = title
  if (category != null) {
    newTitle = newTitle + " | " + category
  }
  newTitle = newTitle + " | CloudPedia.AI"
  return (
    <>
      <Head>
        <title>{newTitle}</title>
        <meta name="description" content="Page Description" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
    </>
  );
};

export default PageHead;
